import englishStrings from "../../locales/en.json"
import spanishStrings from "../../locales/es.json"
import germanStrings from "../../locales/de.json"
import filipinoStrings from "../../locales/fil.json"
import frenchStrings from "../../locales/fr.json"
import frenchCanadianStrings from "../../locales/fr-CA.json"
import italianStrings from "../../locales/it.json"
import dutchStrings from "../../locales/nl.json"
import polishStrings from "../../locales/pl.json"
import portugueseBrazilStrings from "../../locales/pt.json"
import portuguesePortugalStrings from "../../locales/pt-PT.json"
import romanianStrings from "../../locales/ro.json"
import somaliStrings from "../../locales/so.json"
import swahiliStrings from "../../locales/sw.json"
import tagalogStrings from "../../locales/tl.json"
import vietnameseStrings from "../../locales/vi.json"

interface LocaleStrings {
	[key: string]: string;
}

// Please alphabetize by language name (with en/es first) to 
// match the UI list.
const localeToStringsMap : Record<string, LocaleStrings> = {
	"en": englishStrings,
	"es": spanishStrings,
	"nl": dutchStrings,
	"fil": filipinoStrings,
	"fr": frenchStrings,
	"fr-ca": frenchCanadianStrings,
	"de": germanStrings,
	"it": italianStrings,
	"pt": portugueseBrazilStrings,
	"pt-pt": portuguesePortugalStrings,
	"pl": polishStrings,
	"ro": romanianStrings,
	"sw": swahiliStrings,
	"so": somaliStrings,
	"tl": tagalogStrings,
	"vi": vietnameseStrings
};

export function localeStrings(specifiedLocale: string): LocaleStrings {
	return localeToStringsMap[specifiedLocale] || {};
}

export function localeString(key: string, specifiedLocale: string): string {
	const localeStrings : LocaleStrings = localeToStringsMap[specifiedLocale];
	return localeStrings[key] || "";
}